import React, {PropTypes} from 'react';
import AppBar from 'material-ui/AppBar';
import Dialog from 'material-ui/Dialog';
import IconClose from '../../../Icons/IconClose';
import IconButton from 'material-ui/IconButton';
import ProductGridSponsoredList from '../../../Shop/ProductGridSponsoredList';

class PartnerBannerLinkType extends React.Component {

  state = {
    displayModal: false
  };

  static propTypes = {
    styles: PropTypes.object.isRequired,
    bannner: PropTypes.object.isRequired
  };

  chooseProduct = (item) => {
    this.props.onChange(item);
    this.closeSelectModal();

  };

  showSelectModal = () => {
    this.setState({displayModal: true});
  };

  closeSelectModal = () => {
    this.setState({displayModal: false});
  };

  render() {
    let {displayModal} = this.state;
    let {styles, bannner} = this.props;
    let modalAppBar = (<AppBar
      style={{padding: '0 16px'}}
      title="Choose the item"
      iconStyleLeft={{display: 'none'}}
      iconElementLeft={null}
      iconElementRight={
        <IconButton onClick={this.closeSelectModal}><IconClose/></IconButton>
      }
    />);

    return (
      <div>
        <input
          {...styles.buttonLink}
          type="button"
          value="Add Item"
          onClick={() => {
            this.showSelectModal();
          }}
        />
        <div>
          <input disabled {...styles.bannerLinkInternal}
                 type="text"
                 value={bannner.promo ? bannner.promo.name : ''}
          />
        </div>
        <Dialog
          title={modalAppBar}
          modal={false}
          open={displayModal}
          onRequestClose={this.handleClose}
          autoScrollBodyContent={true}>
          <ProductGridSponsoredList onSelect={this.chooseProduct}/>
        </Dialog>
      </div>
    )
  }
}

export default PartnerBannerLinkType;



// WEBPACK FOOTER //
// ./src/components/Partner/PartnerBannerForm/PartnerBannerLinkType/PartnerBannerLinkType.jsx